import React, { useState, useCallback } from 'react';
import { Checkbox, Form, message } from 'antd';
import { useDispatch } from 'react-redux';

import LinkComponent from '../../linkComponent';
import CustomButton from '../../button';
import FormInput from '../../inputWrapper/formInput';
import AuthWrapper from '../authWrapper';

import { useAuth } from '../../../routes/authContext';
import { setActiveTabKey, setIsForgotPassword, setModalOpen, setStep } from '../../../redux/slices/modalSlice';
import { minLength, requiredField, validateEmailInput } from '../../../helpers/validationHelper';

import { INPUT_TYPES } from '../../../constants/componentTypes';

import MainLoader from '../../loader/mainLoader';

const SignInComponent = () => {
  const dispatch = useDispatch();
  const { login } = useAuth();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onLogin = useCallback(
    async ({ username, password }) => {
      setLoading(true);
      try {
        await login(username, password);
      } catch (error) {
        message.error('Login failed. Please check your credentials.');
      } finally {
        setLoading(false);
        dispatch(setModalOpen(false));
      }
    },
    [login, dispatch]
  );

  const handleForgotPassword = useCallback(() => {
    dispatch(setStep('initial'));
    dispatch(setIsForgotPassword(true));
  }, [dispatch]);

  const handleClearData = useCallback(() => {
    form.resetFields();
  }, [form]);
 
  return (
    <AuthWrapper
      footerLink={
        <LinkComponent
          onClick={() =>  dispatch(setActiveTabKey('2'))}
          title={
            <p className='cursor-default m-0'>
              No account yet? <span className='text-blue-link cursor-pointer'>Sign Up</span>
            </p>
          }
          className='bookroad-signup-tab-footerlink w-100 cursor-pointer manrope-14-regular'
        />
      }
    >
      <div className='signin-modal-container relative'>
        {loading && (
          <div className='loading-overlay'>
            <MainLoader style={{ height:150, width: 150 }} />
          </div>
        )}

        <Form
          form={form}
          name='signIn'
          onFinish={onLogin}
          layout='vertical'
          className='signin-form'
          requiredMark={false}
        >
          <FormInput
            label='Email Address'
            name='username'
            // rules={[
            //   requiredField(''),
            //   minLength(3, 'Username must be at least 3 characters')
            // ]}
            rules={[requiredField(''), validateEmailInput]}
            placeholder='Email Address'
            onChange={(e) => form.setFieldsValue({ username: e.target.value.trimStart() })} 
            />

          <FormInput
            label='Password'
            name='password'
            rules={[
              requiredField(''),
              minLength(6, 'Password must be at least 6 characters')
            ]}
            type={INPUT_TYPES.PASSWORD}
            placeholder='Password'
            onChange={(e) => form.setFieldsValue({ password: e.target.value.trim() })}
            tooltipText='Enter your account password.'
          />

          <div className='flex justify-between items-center signin-form-subsection'>
            {/* <Form.Item name='remember' valuePropName='checked' noStyle>
              <Checkbox className='bookroad-signup-tab-checkbox manrope-14-regular'>
                Remember me?
              </Checkbox>
            </Form.Item> */}
            <LinkComponent
              title='Forgot Password?'
              className='pr-0 bookroad-signup-tab-bluelink manrope-14-regular ml-auto'
              onClick={handleForgotPassword}
            />
          </div>

          <CustomButton
            loading={loading}
            title='Sign In'
            className='mt-18 radius-5'
            htmlType='submit'
            disabled={loading}
          />

          {/* <CustomButton
            title='Clear Data'
            className='mt-18 radius-5'
            variant='outline'
            onClick={handleClearData}
          /> */}
        </Form>
      </div>
    </AuthWrapper>
  );
};

export default SignInComponent;
